<template>
  <div>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
          <van-image
            fit="contain"
            :src="require('@/assets/images/index/u111.png')"
          />
      </van-swipe-item>
      <van-swipe-item>
          <van-image
            fit="contain"
            :src="require('@/assets/images/index/u116.png')"
          />
      </van-swipe-item>
      <van-swipe-item>
          <van-image
            fit="contain"
            :src="require('@/assets/images/index/u121.png')"
          />
      </van-swipe-item>
    </van-swipe>

    <div class="ctentstwo">
        <div>
          <van-grid :column-num="3" class="cardcont" :border="false">
          <van-grid-item  @click="Remtof">
              <img src="@/assets/images/index/u127.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('yckm')}}</p>
          </van-grid-item>
          <van-grid-item  @click="Homemake" v-if="Userof.person_type !=1">
              <img src="@/assets/images/index/u101.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('fkyy')}}</p>
          </van-grid-item>
          <van-grid-item  @click="Homekey" v-if="Userof.person_type !=1">
              <img src="@/assets/images/index/u106.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('fxys')}}</p>
          </van-grid-item>
          <van-grid-item  @click="Homeqr">
              <img src="@/assets/images/index/u86.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('ewmkm')}}</p>
          </van-grid-item>
          <van-grid-item  @click="clickCode" >
              <img src="@/assets/images/index/u91.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('smkm')}}</p>
          </van-grid-item>
          <van-grid-item @click="Homeble" >
              <img src="@/assets/images/index/u96.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('yjkm')}}</p>
          </van-grid-item>
        </van-grid>
        </div>
    </div>

    <van-overlay :show="show" @click="turnCameraOff" >
      <div class="qrcode">
      <qrcode
        :qrcode="qrcode"
        v-show="qrcode"
        :camera="camera"
        :torchActive="torchActive"
        @switchCamera="switchCamera"
        @ClickFlash="ClickFlash"
        @turnCameraOff="turnCameraOff"
        @onDecode="onDecode"
      />
      </div>
    </van-overlay>
    
  <Footer :active="active" :person_type="Userof.person_type"></Footer>

  <!-- 弹出窗 -->

    <van-dialog v-model="showst" :show-cancel-button="true" confirm-button-color="#48C9B0" :title="$t('xgmm')"  @confirm="onSubmit">
     <div class="fomes">
       <van-form  class="fromctent">
                <!-- <van-field
                v-model="name"
                :placeholder="$t('yhm')"
                :border="true"
                
                clearable
                size='large'
                /> -->
                <van-field
                    v-model="mobile"
                    :placeholder="$t('sjhm')"
                    :border="true"
                    clearable
                    size='large'
                    />
                <van-field
                v-model="old_password"
                :placeholder="$t('jmm')"
                :border="true"
                clearable
                size='large'
                />
                <van-field
                v-model="password"
                type="password"
                :placeholder="$t('xmm')"
                :border="true"
                clearable
                size='large'
                />
            </van-form>
     </div>

    </van-dialog>
    
  </div>
</template>
<script>
import { Dialog } from 'vant';
import  qrcode from '@/components/QrcodeReader'
import { Toast } from 'vant';
import {translateQRcode} from '@/utils/index.js'
import axios from 'axios'
import qs from 'qs'
export default {
  components:{
    qrcode,

  },
  data(){
    return{
      showst:false,
      mobile:'',
      password:'',
      old_password:'',

      active: 0,

      qrcode: false,
      torchActive: false,
      camera: 'off',
      Userof:JSON.parse(window.localStorage.getItem('getTokendata')),
      show: false,
      equipmentlist:null,
      datetrans:null,
      address:localStorage.getItem("address")?localStorage.getItem:'+86'
    }
  },
  mounted(){
    this.onShowst()
    this.getequipment()
  },
  methods:{
    onShowst(){
      if(this.Userof.password == '21218cca77804d2ba1922c33e0151105'){
        this.showst = true
      }else{
        this.showst = false
      }
    },
    onSubmit(){
      let mobiles =this.address+'-'+ this.mobile
        let data={
            method:"co.wx.pwd.modify",
            // name:this.name,
            mobile:mobiles,
            old_password:this.$md5(this.old_password),
            password:this.$md5(this.password)
        }
        this.$serve(data).then(res=>{
            if(res.data.code==0){
                Toast.success(this.$t('szcg'));
                window.localStorage.removeItem('getTokendata')
                this.$router.push({ path: '/login' })
            }else{
                Toast.fail(this.$t('szsb'));
            }
        })
    },
    Remtof(){
      this.$router.push({ path: '/Homerote' })
    },
    //访客预约
    Homemake(){
      this.$router.push({ path: '/Homemake' })
    },
    // 分享钥匙
    Homekey(){
      this.$router.push({ path: '/Homekey' })
    },
    // 二维码开门
    Homeqr(){
      this.$router.push({ path: '/Homeqr' })
    },
    // 蓝牙
    Homeble(){
      this.$router.push({ path: '/Homeble' })
    },
    //远程设备列表

    getequipment(){
      let data={
        method:'co.wx.remote.device.list',
        user_id:this.Userof.user_id,
        page_index:1,
        page_size:10,
        keyword:''
      }
      this.$serve(data).then(res=>{
        if(res.data.code==0){
          this.equipmentlist = res.data.data
          console.log(this.equipmentlist)
        }
        
      })
    },

    // 打开相机
    clickCode() {
      this.show = true
      // camera:: 'rear'--前摄像头，'front'后摄像头，'off'关闭摄像头，会获取最后一帧显示，'auto'开始获取摄像头
      this.qrcode = true
      this.camera = 'rear'
      console.log(this.camera)
    },
    // 扫码结果回调
    onDecode(result) {
       // result, 扫描结果，可以根据自己的需求来实现相应的功能 
      console.log(`999909`,result)
      this.datetrans =  translateQRcode(result,false)
      console.log(this.datetrans)

      let pamast= {
        method : 'co.wx.remote.device.get',
        signature : '',
        user_id : this.Userof.user_id,
        device_no : this.datetrans[0],
        platform: 'weixin2'
      }

      this.$serve(pamast).then(res=>{
        console.log(`9909`,res)
        if(res.data.code==0){
          let data={
            method : 'mqtt.door.open',
            userId:this.Userof.user_id,
            serial:res.data.data.serial,
            password:res.data.data.password,
            platform: 'weixin2'
          }
          data = qs.stringify(data)
          axios.post('https://web.fondcard.net/open/mqtt/api.php?method=mqtt.door.open',data).then(res=>{
              if(res.data.code==0){
                  Toast.success(this.$t('kmcg'));
              }else{
                  Toast.fail(this.$t('kmsb'));
              }
          })  
        }else{
            Toast.fail(this.$t('sbbczhmqx'));
        }
      })
      
      this.turnCameraOff()
    },
    // 相机反转
    switchCamera() {
      switch (this.camera) {
        case 'front':
          this.camera = 'rear'
          break
        case 'rear':
          this.camera = 'front'
          break
        default:
          this.$toast(this.$t('cw'))
      }
    },
    // 关闭相机？？？？？？
    turnCameraOff() {
      this.camera = 'off'
      this.qrcode = false
      this.show = false
    },
    // 打开手电筒
    ClickFlash() {
      switch (this.torchActive) {
        case true:
          this.torchActive = false
          break
        case false:
          this.torchActive = true
          break
        default:
          this.$toast(this.$t('cw'))
      }
    },

    // 检查是否调用摄像头
    async onInit(promise) {
      try {
        await promise
      } catch (error) {
        console.log(error)
      }
    },
  }

}
</script>

<style scoped>
  .my-swipe img{
    width: 100%;
    height: 360px;
  }
  .ctentstwo{
    display: flex;
  }
  .imgs{
    display: flex;
    flex: 1;
    justify-items: center;
    align-items: center;
  }
  .imgs img{
    width: 22px;
    height: 38px;
    margin-right: 5px;
    margin-top: 15px;
  }
  .cardcont{
    flex: 20;
    margin-top: 35px;
  }
  .cardcont img{
    width: 90px;
  } 
  .cardcont >>> .van-grid-item__content{
    padding: 10px 4px;
  }
  .qrcode{
    height: 100%;
  }
  .fomes{
    padding: 0px 20px 30px 20px;
  }
  .fromctent{
    width: 88%;
    margin: 0 auto;
    margin-top:30px;
}
.fromctent >>>.van-field__left-icon .van-icon-friends{
    font-size: 26px;
    margin-left: -5px;
    color: #CCCCCC;
}
.fromctent >>>.van-cell--large{
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    padding: 8px;
    margin-bottom: 10px;
}
.fromctent >>>.van-cell--center{
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    padding: 4px;
}
.fromctent >>>.van-field__left-icon .van-icon-bag{
    font-size: 28px;
    /* margin-left: 2px; */
    color: #CCCCCC;
}

</style>